import React, { useState } from 'react';
import useInView from '../../hooks/useInView';
import './FAQ.css';

const faqs = [
  {
    question: 'Why was RentWise created?',
    answer:
      'RentWise was born out of personal experience. Our founders lost thousands of dollars in security deposits as college renters and realized there was no tool designed to protect people like them. We built RentWise to change that — to give every renter the tools and confidence to protect themselves from day one.',
  },
  {
    question: 'When is RentWise launching?',
    answer:
      "We're building toward a public launch and growing our community of early supporters. Join the waitlist to get priority access, help shape the product, and be part of the rental revolution from the start.",
  },
  {
    question: 'Is RentWise free?',
    answer:
      'Yes, RentWise offer is free for renters & landlords. Join out waitlist to get early access!',
  },
  {
    question: 'Can landlords use RentWise too?',
    answer:
      "Yes. RentWise creates transparency on both sides. Good landlords benefit from organized tenants, clear communication, and documented records. Our goal isn't to demonize landlords — it's to give renters the tools they need to protect themselves.",
  }
];

const FAQ = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section ref={ref} className={`faq${inView ? ' faq--visible' : ''}`}>
      <div className="faq__container">
        <div className="faq__header">
          <p className="faq__eyebrow">FAQ</p>
          <h2 className="faq__headline">Questions? We've got answers.</h2>
        </div>

        <ul className="faq__list">
          {faqs.map((item, i) => (
            <li
              key={i}
              className={`faq__item faq__item--${i}${openIndex === i ? ' faq__item--open' : ''}`}
            >
              <button
                className="faq__question"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
              >
                {item.question}
                <span className="faq__chevron" aria-hidden="true" />
              </button>
              <div className="faq__answer">
                <p className="faq__answer-text">{item.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQ;
